module.exports = __webpack_public_path__ + "img/virtual-area.b50e56dc.png";